$(function(){
	//alert();
	console.log('backend.js test');
	$('#breadcrumb').addClass('backendJStest');
});
